angular.module('signalview.globalEvents', [
    'restangular',
    'signalboost',
    'signalview.timePicker',
    'signalview.autoSuggestInput',
    'sfx.ui',
]);
